import React from 'react';
import PropTypes from 'prop-types';

import { forms as Forms } from '@breezeway/brzw-components';

const FormControlTextarea = ({
  input: { onChange, value },
  meta: { touched, error, warning },
  id,
  label,
  placeholder,
  required,
  type,
}) => {
  const withError = touched && (error || warning) ? error : null;

  return (
    <Forms.Textarea
      id={id}
      isRequired={required}
      labelText={label}
      onChange={onChange}
      placeholderText={placeholder}
      type={type}
      value={value}
      withError={withError}
    />
  );
};

FormControlTextarea.propTypes = {
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.string,
  meta: PropTypes.shape({}),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string,
};

FormControlTextarea.defaultProps = {
  type: 'text',
};

export default FormControlTextarea;
